import { useEffect, useState } from "react";
import { useVehiclesStore } from "../../context/useVehiclesStore";
import { useUserAuthStore } from "../../context/useUserAuthStore";
import Modal from "../ui/Modal";

import BookingCreateModal from "../bookings/BookingCreateModal";

function VehicleForm({ initial, onSubmit }) {
  const [form, setForm] = useState(
    initial ?? {
      make: "",
      model: "",
      color: "",
      vehicleType: "",
      registrationNumber: "",
      organization: "",
      vinNumber: "",
    }
  );
  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <form className="form-grid" onSubmit={(e) => { e.preventDefault(); onSubmit(form); }}>
      <input name="make" placeholder="Make" value={form.make} onChange={change} />
      <input name="model" placeholder="Model" value={form.model} onChange={change} />
      <input name="color" placeholder="Color" value={form.color} onChange={change} />
      <input name="vehicleType" placeholder="Type" value={form.vehicleType} onChange={change} />
      <input name="registrationNumber" placeholder="Registration Number" value={form.registrationNumber} onChange={change} required />
      <input name="organization" placeholder="Organization" value={form.organization} onChange={change} />
      <input name="vinNumber" placeholder="VIN" value={form.vinNumber} onChange={change} />
      <div className="form-actions"><button type="submit">Save</button></div>
    </form>
  );
}

export default function VehiclesTab() {
  const { vehicles, fetchVehicles, createVehicle, updateVehicle, deleteVehicle, loading } =
    useVehiclesStore();
  const { currentUser } = useUserAuthStore();
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [bookingVehicle, setBookingVehicle] = useState(null);
  const isAdmin = currentUser?.role === "admin";

  useEffect(() => {
    if (!vehicles.length) fetchVehicles();
  }, [fetchVehicles, vehicles.length]);

  //const visibleVehicles = isAdmin
  //  ? vehicles
  //  : vehicles.filter(v => v.userId === currentUser.id);

  const visibleVehicles = vehicles;

  if (loading) return <div>Loading vehicles...</div>;

return (
  <div>
    {/* Toolbar */}
    {isAdmin && (
      <div className="toolbar">
        <button
          onClick={() => {
            setEditing(null);
            setOpen(true);
          }}
        >
          + New Vehicle
        </button>
      </div>
    )}

    <div className="table">
      <div className="table-row table-head">
        <div>Reg</div>
        <div>Make</div>
        <div>Model</div>
        <div>Color</div>
        <div>Type</div>
        <div>Org</div>
        <div>VIN</div>
        <div></div>
      </div>

      {visibleVehicles.map((v) => (
        <div className="table-row" key={v.id}>
          <div>{v.registrationNumber}</div>
          <div>{v.make}</div>
          <div>{v.model}</div>
          <div>{v.color}</div>
          <div>{v.vehicleType}</div>
          <div>{v.organization}</div>
          <div>{v.vinNumber}</div>

          <div className="row-actions">
            {/* Book for all users */}
            <button
              onClick={() => {
                setBookingVehicle(v);
              }}
            >
              Book
            </button>

            {/* Admin-only actions */}
            {isAdmin && (
              <>
                <button
                  onClick={() => {
                    setEditing(v);
                    setOpen(true);
                  }}
                >
                  Edit
                </button>

                <button
                  className="danger"
                  onClick={() => deleteVehicle(v.id)}
                >
                  Delete
                </button>
              </>
            )}
          </div>
        </div>
      ))}
    </div>

    {/* Vehicle Create / Edit */}
    {isAdmin && (
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title={editing ? "Edit Vehicle" : "New Vehicle"}
      >
        <VehicleForm
          initial={editing}
          onSubmit={(data) => {
            if (editing) updateVehicle(editing.id, data);
            else createVehicle(data);
            setOpen(false);
            setEditing(null);
          }}
        />
      </Modal>
    )}

    {/* Booking modal */}
    {bookingVehicle && (
      <BookingCreateModal
        presetVehicle={bookingVehicle}
        onClose={() => setBookingVehicle(null)}
        onDone={() => {
          setBookingVehicle(null);
        }}
      />
    )}
  </div>
);
}
